import useNavigateKeepingSearch from 'src/Hooks/Shared/useNavigateKeepingSearch';
import { trackFinancesActionClicked } from 'src/Services/Mixpanel/events';

export interface OperationActions {
  addExpense: () => void;
  addIncome: () => void;
  addTransfer: () => void;
}

/**
 * The three ways to record money, shared by the operations toolbar and the Finances hub
 * tile. Extracted so both entry points always open the same drawers — duplicating the
 * routes is how they drift apart.
 */
const useOperationActions = (source: 'home' | 'operations'): OperationActions => {
  const navigate = useNavigateKeepingSearch();

  return {
    addExpense: () => {
      trackFinancesActionClicked({ action: 'add_expense', source });
      navigate('new', { state: { isIncome: false } });
    },
    addIncome: () => {
      trackFinancesActionClicked({ action: 'add_income', source });
      navigate('new', { state: { isIncome: true } });
    },
    addTransfer: () => {
      trackFinancesActionClicked({ action: 'add_transfer', source });
      navigate('new-transfer');
    },
  };
};

export default useOperationActions;
